<rms-mod>
  <h1>SKU Price History</h1>
  @if(CoffeeName) { <h2 class="coffee-name">{{CoffeeName}}</h2> }
  <div style="height:60vh">
    <rms-table [data]="HistoricalPrices" [columns]="columns"></rms-table>
  </div>
</rms-mod>
